import { render, staticRenderFns } from "./channel.overview.vue?vue&type=template&id=1de7bcdd&scoped=true"
import script from "./channel.overview.vue?vue&type=script&setup=true&lang=js"
export * from "./channel.overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel.overview.vue?vue&type=style&index=0&id=1de7bcdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7bcdd",
  null
  
)

export default component.exports